<!--  -->
<template>
  <div>
    <div class="form_box">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="账户名称">
          <el-input v-model="form.account_name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="登录密码">
          <el-input v-model="form.login_pwd" autocomplete="off" show-password />
        </el-form-item>
        <el-form-item label="支付密码">
          <el-input id="enterName" v-model="form.pay_pwd" name="userName111" autocomplete="off" show-password />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="addcread">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="padding:0 40px">
      <el-table
        :data="tableData"
        style="width:100%; height: 100%;"
        border
        max-height="500"
      >
        <el-table-column
          align="center"
          label="账户名称"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.show">{{ scope.row.account_name }}</span>
            <el-input
              v-else
              v-model="account_name"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="登录密码"
        >
          <template slot-scope="scope">
            <div v-if="!scope.row.show">
              <input v-model="scope.row.login_pwd" readonly style="width:90px" :type="scope.row.loginpwdshow?&quot;password&quot;:&quot;text&quot;">
              <i class="el-input__icon el-icon-view el-input__clear" @click="changePwd(scope.$index)" />
            </div>
            <!-- <el-input v-if="!scope.row.show" :type='pwdFlag ? "password":"text"' v-model="scope.row.login_pwd" /> -->
            <!-- <span v-if="!scope.row.show">{{ scope.row.login_pwd }}</span> -->
            <el-input
              v-else
              v-model="login_pwd"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="支付密码"
        >
          <template slot-scope="scope">
            <div v-if="!scope.row.show">
              <input v-model="scope.row.pay_pwd" style="width:90px" readonly :type="scope.row.paypwdshow?&quot;password&quot;:&quot;text&quot;">
              <i class="el-input__icon el-icon-view el-input__clear" @click="changepaypwd(scope.$index)" />
            </div>
            <!-- <el-input v-if="!scope.row.show" :type='pwdFlag ? "password":"text"' v-model="scope.row.pay_pwd" /> -->
            <!-- <span v-if="!scope.row.show">{{ scope.row.pay_pwd }}</span> -->
            <el-input
              v-else
              v-model="pay_pwd"
            />
          </template>
        </el-table-column>

        <el-table-column
          :key="mathRandom"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <span v-show="!scope.row.show">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="modifyAccount(scope.$index, scope.row)"
              >
                修改
              </el-button>
              <el-button
                type="text"
                size="small"
                @click.native.prevent="deleteAccount(scope.row.id)"
              >
                删除
              </el-button>
            </span>
            <span v-show="scope.row.show">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="cancelAccount(scope.$index)"
              >
                取消修改
              </el-button>
              <el-button
                type="text"
                size="small"
                @click.native.prevent="confirmAccount(scope.$index,scope.row)"
              >
                确认修改
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { testwechatadd, accounttestlist, testwechatupdata, deletetestwechat } from '@/api/providerAccountManagement/servicePorviderList.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      form: {
        account_name: '',
        login_pwd: '',
        pay_pwd: ''
      },
      pwdFlag: true, // 密码标示 true表示当前是密码形式
      account_name: '',
      login_pwd: '',
      pay_pwd: '',
      mathRandom: null,

      tableData: [],
      query: {
        page: 1,
        pageSize: 10
      },
      total: null
    }
  },
  created() {
    this.accountlist()
  },
  mounted() {
  },
  methods: {
    async accountlist() {
      const data = await accounttestlist(this.query)
      console.log('data', data.data.list)
      this.tableData = data.data.list
      this.total = data.data.total
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].show = false
        this.tableData[i].loginpwdshow = true
        this.tableData[i].paypwdshow = true
      }
    },
    async addcread() {
      //     account_name: '',
      // login_pwd: '',
      // pay_pwd: '',
      if (this.form.account_name === '') {
        this.$message.error('请填写账户名称')
        return
      }
      if (this.form.login_pwd === '') {
        this.$message.error('请填写登录密码')
        return
      }
      if (this.form.pay_pwd === '') {
        this.$message.error('请填写支付密码')
        return
      }
      const data = await testwechatadd(this.form)
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      this.rest()
      this.accountlist()
      console.log('data', data)
    },

    rest() {
      this.form.account_name = ''
      this.form.login_pwd = ''
      this.form.pay_pwd = ''
    },
    changePwd(index) {
      // 密码标示取反即可
      this.tableData[index].loginpwdshow = !this.tableData[index].loginpwdshow
      this.mathRandom = Math.random()
    },
    changepaypwd(index) {
      this.tableData[index].paypwdshow = !this.tableData[index].paypwdshow
      this.mathRandom = Math.random()
    },
    modifyAccount(index, data) {
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].show = false
      }
      this.tableData[index].show = true
      this.account_name = data.account_name
      this.login_pwd = data.login_pwd
      this.pay_pwd = data.pay_pwd
      this.mathRandom = Math.random()
    },
    // 取消修改
    cancelAccount(index) {
      this.tableData[index].show = false
      this.mathRandom = Math.random()
    },
    async confirmAccount(index, item) {
      const id = item.id
      const account_name = this.account_name
      const login_pwd = this.login_pwd
      const pay_pwd = this.pay_pwd
      const data = await testwechatupdata(id, account_name, login_pwd, pay_pwd)
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.mathRandom = Math.random()
      this.accountlist()
      this.tableData[index].show = false
      console.log('data', data)
    },
    async deleteAccount(id) {
      const data = await deletetestwechat(id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.accountlist()
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.accountlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.accountlist()
    },
    resback() {
      this.rest()
    },
    updatawechat() {
      this.accountlist()
    },
    rew() {

    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.form_box{
  margin-top: 30px;
  padding: 30px;
}
</style>
